<template>
  <div class="asd20-directory-group-results-page">
    <div
      class="select-team"
      v-if="!selectedGroup || selectedGroupPeopleListItems.length < 1"
    >
      <!-- <p v-if="selectedGroupPeopleListItems.length < 1">
        There are no members listed for this team.
      </p> -->
      <p v-if="!selectedGroup">
        Use <b>Search</b> or <b>Select a Team</b> to see more information.
      </p>
    </div>
    <div
      class="show-selected-team"
      v-if="selectedGroup || selectedGroupPeopleListItems.length > 0"
    >
      <!-- <p v-if="selectedGroupPeopleListItems.length < 1">
        There are no members listed for this team.
      </p> -->
      <h2 v-if="selectedGroup">
        Viewing Team: <b>{{ selectedGroup.title }}</b>
      </h2>
      <p>Choose a different team using the <b>Select a Team</b> button.</p>
    </div>

    <asd20-department-contact-card
      v-if="selectedGroup"
      :group="selectedGroup"
    />
    <br />
    <asd20-list multi-column :column-width="640">
      <asd20-list-item
        v-for="(item, index) in selectedGroupPeopleListItems"
        :key="index"
        v-bind="item"
        @click.native="onPersonClick(item)"
      />
    </asd20-list>
    <Asd20PersonModal
      :person="selectedPerson"
      :open="!!selectedPerson"
      @dismiss="selectedPerson = null"
    />
  </div>
</template>

<script>
import { get } from 'vuex-pathify'
import Asd20List from '@asd20/ui/src/components/organisms/Asd20List'
import Asd20ListItem from '@asd20/ui/src/components/molecules/Asd20ListItem'
import Asd20PersonModal from '@asd20/ui/src/components/organisms/Asd20PersonModal'
// import Asd20Modal from '@asd20/ui/src/components/molecules/Asd20Modal'
// import Asd20Viewport from '@asd20/ui/src/components/atoms/Asd20Viewport'
import Asd20DepartmentContactCard from '@asd20/ui/src/components/molecules/Asd20DepartmentContactCard'

export default {
  name: 'Asd20DirectoryGroupResultsPage',

  components: {
    Asd20List,
    Asd20ListItem,
    Asd20PersonModal,
    // Asd20Modal,
    // Asd20Viewport,
    Asd20DepartmentContactCard,
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.dispatch('groups/selectGroupBySlug', to.params.slug)
    })
  },

  beforeRouteUpdate(to, from, next) {
    this.$store.dispatch('groups/selectGroupBySlug', to.params.slug)
    next()
  },

  props: {
    abbreviation: { type: String },
    slug: { type: String },
  },

  data: () => ({
    selectedPerson: null,
  }),

  computed: {
    selectedGroup: get('groups/selectedGroup'),
    selectedGroupPeopleListItems: get('groups/selectedGroupPeopleListItems'),
    selectedOrganizationId: get('selectedOrganizationId'),
  },

  methods: {
    onPersonClick({ person }) {
      this.selectedPerson = {
        ...person,
        jobTitles: [person.title],
        thumbnailUrl: person.photoUrl,
        organization:
          person.employee &&
          person.employee.organization &&
          person.employee.organization.title,
        office: person.employee && person.employee.office,
      }
    },
  },
}
</script>

<style lang="scss">
@import '@asd20/ui/src/design/_mixins.scss';
@import '@asd20/ui/src/design/_variables.scss';
.asd20-directory-group-results-page {
  margin: space(0.5);
}
.asd20-icon {
  --fill-color: var(--color__accent-t50) !important;
}
.asd20-directory-group-results-page {
  .select-team {
    margin: space(1);
  }
  .show-selected-team {
    margin: space(1) space(0.5) space(0.5) space(0.5);
    font-family: var(--website-typography__font-family-headlines);
  }
}
@media (min-width: 1024px) {
  .asd20-directory-group-results-page {
    padding: space(1);
    .asd20-modal-container {
      padding: 0;
    }
    .asd20-modal {
      margin-top: auto;
      margin-bottom: auto;
      max-width: 40vw;
    }
  }
}
@media (min-width: 1250px) {
  .asd20-directory-group-results-page {
    .show-selected-team {
      display: none;
    }
  }
}
</style>
